import React from "react";
import EADialog from "../EADialog";
import EAButtonBar from "../EAButtonBar";
import EAButton from "../EAButton";

/**
 * Über den Hook useConfirmation() eine Konstante erstellen, welche dann als Funktion aufgerufen werden kann und als Parameter
 * ein Objekt entsprechend der Parameter dieser Komponente erwartet.
 * @param open Wird durch den Hook automatisch gesetzt
 * @param title Die Überschrift
 * @param description der Content
 * @param onSubmit Aktion, welche nach dem Bestätigen ausgeführt werden soll
 * @param onClose Aktion, welche beim Abbrechen ausgeführt werden soll. (Wenn nicht angegeben, gibt es nur die Bestätigen Schaltfläche)
 * @param submitLabel Label des Submit Buttons
 * @param cancelLabel Label des Abbrechen Buttons
 * @returns {JSX.Element}
 * @constructor
 */
export const ConfirmationDialog = ({
                                       open, title, description, onSubmit, onClose,
                                       submitLabel = "Bestätigen",
                                       cancelLabel = "Abbrechen"
                                   }) => {
    return (
        <EADialog
            open={open}
            closeFunction={onClose}
            titleChildren={title}
            content={description}
            buttons={
                <EAButtonBar>
                    {onClose && <EAButton id="confirmDialog-cancel" label={cancelLabel} onClick={onClose}/>}
                    <EAButton id="confirmDialog-submit" color="primary" label={submitLabel} onClick={onSubmit}/>
                </EAButtonBar>
            }
        />
    );
};
